import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useState, useContext } from 'react';
import { IconButton, Box, Menu, MenuItem, } from '@mui/material';
import { signOut } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
// Internal dependencies
import { axiosClient } from '../../axios';
import { auth, UserContext } from '../../auth';
import { CLIENT_ENDPOINTS, LOG_LEVELS, SERVICES, ENDPOINTS, } from '../../constants';
import { appStyles } from '../../App.styles';
import { avatarSGStyles } from './avatarSG.styles';
import { AvatarIconSG } from '../icons';
/**
 * Customized Button
 * @param {ButtonProps} props
 * @returns {JSX.Element}
 */
export const AvatarSG = function (props) {
    // Extract translation function
    const { t } = useTranslation();
    // Load user credential
    const user = useContext(UserContext);
    // Use React Router Dom navigate
    const navigate = useNavigate();
    const { handleDrawerToggle } = props;
    // User profile anchor
    const [profileAnchor, setProfileAnchor] = useState(null);
    // Open flag for User profile menu
    const profileOpen = Boolean(profileAnchor);
    /**
     * Handle close profile action
     * @returns success/fail
     */
    const handleProfileClose = () => {
        setProfileAnchor(null);
        return true;
    };
    /**
     * Handle click profile action
     * @param event Click event
     * @returns success/fail
     */
    const handleProfileClick = (event) => {
        setProfileAnchor(event.currentTarget);
        return true;
    };
    /**
     * Sign out
     */
    const handleSignOut = () => {
        signOut(auth).then(() => {
            if (handleDrawerToggle) {
                // If it's in the side bar
                handleDrawerToggle();
            }
            navigate(CLIENT_ENDPOINTS.CHAT);
            return true;
        }).catch((err) => {
            axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                level: LOG_LEVELS.ERROR,
                logMessage: `AvatarSG, handleSignOut, ${err === null || err === void 0 ? void 0 : err.message}`,
                metadata: {
                    env: process.env.ENV,
                    service: SERVICES.HEADER,
                    userId: user === null || user === void 0 ? void 0 : user.uid,
                    email: user === null || user === void 0 ? void 0 : user.email,
                    userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                },
            });
            toast.error(t('Something went wrong. We are figuring it out.'));
            if (handleDrawerToggle) {
                // If it's in the side bar
                handleDrawerToggle();
            }
            return false;
        });
        return true;
    };
    const open = true;
    return (_jsxs(Box, { children: [_jsx(IconButton
            // Profile button
            , Object.assign({ 
                // Profile button
                onClick: handleProfileClick, "aria-label": "Profile button", "aria-controls": open ? 'profile-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined }, props, { children: _jsx(AvatarIconSG, { sx: { color: 'blackDark.main' } }) })), _jsx(Menu, Object.assign({ anchorEl: profileAnchor, id: "profile-menu", open: profileOpen, onClose: handleProfileClose, onClick: handleProfileClose, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, sx: {
                    '& div': {
                        borderRadius: '1rem',
                    },
                    '& ul': Object.assign({ 
                        //borderColor: '#C0C9C1',
                        backgroundColor: 'white.main' }, appStyles.boxShadow),
                } }, { children: _jsxs(Box, { children: [_jsx(MenuItem, Object.assign({ sx: avatarSGStyles.menuItem, onClick: () => {
                                navigate(CLIENT_ENDPOINTS.SETTINGS);
                                if (handleDrawerToggle) {
                                    handleDrawerToggle();
                                }
                            } }, { children: t('Settings') })), _jsx(MenuItem, Object.assign({ sx: avatarSGStyles.menuItem, onClick: handleSignOut }, { children: t('Log out') }))] }) }))] }));
};
